/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryGroupSubscriptionUpdateServicePackagePlanOptions
 */
export interface LaundryGroupSubscriptionUpdateServicePackagePlanOptions {
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupSubscriptionUpdateServicePackagePlanOptions
     */
    id: string;
}

/**
 * Check if a given object implements the LaundryGroupSubscriptionUpdateServicePackagePlanOptions interface.
 */
export function instanceOfLaundryGroupSubscriptionUpdateServicePackagePlanOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function LaundryGroupSubscriptionUpdateServicePackagePlanOptionsFromJSON(json: any): LaundryGroupSubscriptionUpdateServicePackagePlanOptions {
    return LaundryGroupSubscriptionUpdateServicePackagePlanOptionsFromJSONTyped(json, false);
}

export function LaundryGroupSubscriptionUpdateServicePackagePlanOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupSubscriptionUpdateServicePackagePlanOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function LaundryGroupSubscriptionUpdateServicePackagePlanOptionsToJSON(value?: LaundryGroupSubscriptionUpdateServicePackagePlanOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

